import { Handle, Position } from "@xyflow/react";

export default function GraphLevelANode({ data }) {
    // Used in

    // PROPERTIES

    // HOOKS

    // METHODS

    // BUILD
    return (
        <div className="w-[220px] max-w-[220px] bg-backgroundLight1 border border-greyLight3 rounded-[14px] px-[12px] py-[8px] shadow-sm">
            {/** where edges arrive */}
            <Handle type="target" position={Position.Top} />
            {/** Content */}
            <div className="text-greyLight9 font-semibold text-[14px] leading-tight overflow-hidden line-clamp-2">
                {data.task}
            </div>
            {data.grade && (
                <div className="text-white/60 text-[12px] mt-[4px]">
                    {data.grade}
                </div>
            )}
            {/** where edges leave */}
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}